import { fromJS } from 'immutable'

import { LOCATION_CHANGE } from 'react-router-redux'

import {
  UPDATE_CLIENT_DETAIL,
  UPDATE_USER_DETAIL,
  STATE_CHANGED,
  CLIENT_DATA_CHANGED,
  LOCATION_CHANGED,
  VEHICLES_FETCHED,
  NOTIFICATIONS_FETCHED
} from './constants'


export const initialState = fromJS({
  vehicles: [],
  client: {
    phone_number: '',
    rfc: '',
    gender: '',
    birthdate: '',
    zip_code: '',
    client_type: ''
  },
  user: {
    uuid: '',
    email: '',
    first_name: '',
    last_name: '',
    is_active: false,
    is_staff: false,
    picture: ''
  },
  state: {
    id: null,
    name: ''
  },
  location: {
    id: null,
    name: ''
  },
  notifications_list: []
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case VEHICLES_FETCHED:
      return state.merge({vehicles: action.vehicles})
    case UPDATE_USER_DETAIL:
      return state.merge({user: action.user})
    case UPDATE_CLIENT_DETAIL:
      return state.merge({client: action.client})
    case STATE_CHANGED:
      return state.merge({state: action.state})
    case LOCATION_CHANGED:
      return state.merge({location: action.location})
    case CLIENT_DATA_CHANGED:
      const client = state.get('client').toJS()
      return state.merge({
        client: {
          ...client,
          [action.name]: action.value
        }
      })
    case LOCATION_CHANGE:
      return initialState
    case NOTIFICATIONS_FETCHED:
      return state.merge({notifications_list: action.notifications_list})
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/reducer.js